import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

export const ErrorText: React.FC = () => {
  return <UIText3 color="error_100">Что-то пошло не так. Попробуйте позже</UIText3>;
};
